'use client';

/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/iframe-has-title */

import React, { FC } from 'react';

const PartServiceContent: FC = () => (
  <section>
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2174.1245074615854!2d24.148899999999998!3d56.980928!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46eecfaa5a389aad%3A0x2fab562e59e1c2fe!2sVISSA%20Autoserviss!5e0!3m2!1sru!2spt!4v1708197878875!5m2!1sru!2spt"
      width="100%"
      height="450"
      style={{ border: '0' }}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
  </section>
);

export default PartServiceContent;
